export default [
  {
    'id': 20000,
    'lat': 34.651926,
    'lng': 135.509474,
    'name': 'コウノトリ舎'
  },
  {
    'id': 20001,
    'lat': 34.652249,
    'lng': 135.509306,
    'name': 'レッサー\nパンダ舎'
  },
  {
    'id': 20002,
    'lat': 34.652727,
    'lng': 135.509321,
    'name': 'オオカミ舎'
  },
  {
    'id': 20003,
    'lat': 34.653414,
    'lng': 135.50916,
    'name': 'トラ舎'
  },
  {
    'id': 20004,
    'lat': 34.653648,
    'lng': 135.508787,
    'name': 'ジャガー舎'
  },
  {
    'id': 20005,
    'lat': 34.653747,
    'lng': 135.508539,
    'name': 'ヤマネコ舎'
  },
  {
    'id': 20006,
    'lat': 34.652932,
    'lng': 135.508287,
    'name': 'ライオン舎'
  },
  {
    'id': 20007,
    'lat': 34.652618,
    'lng': 135.508401,
    'name': 'ハイエナ舎'
  },
  {
    'id': 20008,
    'lat': 34.652787,
    'lng': 135.508999,
    'name': 'キリン舎'
  },
  {
    'id': 20009,
    'lat': 34.652144,
    'lng': 135.507830,
    'name': 'サイ舎'
  },
  {
    'id': 20010,
    'lat': 34.651743,
    'lng': 135.50813,
    'name': 'カバ舎'
  },
  {
    'id': 20011,
    'lat': 34.651399,
    'lng': 135.507816,
    'name': 'アイファー\n（爬虫類生態館）'
  },
  {
    'id': 20012,
    'lat': 34.651455,
    'lng': 135.508581,
    'name': 'ツル舎'
  },
  {
    'id': 20013,
    'lat': 34.651725,
    'lng': 135.508983,
    'name': 'ペンギン舎'
  },
  {
    'id': 20014,
    'lat': 34.65039,
    'lng': 135.507659,
    'name': 'チンパンジー舎'
  },
  {
    'id': 20015,
    'lat': 34.650149,
    'lng': 135.507324,
    'name': 'アシカ池'
  },
  {
    'id': 20016,
    'lat': 34.649992,
    'lng': 135.507969,
    'name': 'ゾウ舎'
  },
  {
    'id': 20017,
    'lat': 34.649931,
    'lng': 135.508906,
    'name': 'コアラ館'
  },
  {
    'id': 20018,
    'lat': 34.650367,
    'lng': 135.509256,
    'name': '夜行性動物舎'
  },
  {
    'id': 20019,
    'lat': 34.648871,
    'lng': 135.508395,
    'name': '鳥の楽園'
  },
  {
    'id': 20020,
    'lat': 34.648936,
    'lng': 135.507115,
    'name': 'ホッキョク\nグマ舎'
  },
  {
    'id': 20021,
    'lat': 34.649000,
    'lng': 135.509681,
    'name': 'てんしばゲート'
  },
  {
    'id': 20022,
    'lat': 34.650812,
    'lng': 135.507016,
    'name': '新世界ゲート'
  },
  {
    'id': 20023,
    'lat': 34.650526,
    'lng': 135.508915,
    'name': 'レクチャー\nルーム'
  }
];


// WEBPACK FOOTER //
// ./map/js/ih/extend/AnimalHouseData.js